import {
    GET_EXPLORE_DATA,
    GET_EXPLORE_DATA_SUCCESS,
    UPDATE_MEDIA_VIEW_COUNT_EXPLORE_SUCCESS,
    RESET_EXPLORE_DATA
} from '../constants/actionTypes';



export const getExploreData = (payload) => ({
    type: GET_EXPLORE_DATA,
    payload
});

export const getExploreDataSuccess = payload => ({
    type: GET_EXPLORE_DATA_SUCCESS,
    payload
});

export const updateMediaViewCountExploreSuccess = payload => ({
    type: UPDATE_MEDIA_VIEW_COUNT_EXPLORE_SUCCESS,
    payload
});

export const resetExploreData = () => ({
    type: RESET_EXPLORE_DATA
});